import React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';
import { Button, Card, CardContent, Typography, units } from '@ha/dsl';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';

interface Props {
  title: string;
  text: string;
  buttonText: string;
  buttonUrl: string;
}

export const styles = () =>
  createStyles({
    root: {
      padding: units.txb(1.25, 1.5, 1.25),
    },
    title: {
      marginBottom: units.rem(0.5),
    },
    text: {
      marginBottom: units.rem(1.25),
    },
  });

const BlogCardInternal: React.FC<Props & WithStyles<typeof styles>> = ({
  title,
  text,
  buttonText,
  buttonUrl,
  classes,
}) => (
  <Card>
    <CardContent className={classes.root}>
      <Typography.H2
        component="h2"
        className={classes.title}
        data-test-locator="Blog BlogCard Title"
      >
        {title}
      </Typography.H2>
      <Typography.Paragraph
        component="p"
        className={classes.text}
        data-test-locator="Blog BlogCard Text"
      >
        {text}
      </Typography.Paragraph>
      <Track
        name="Clicked on lead capture CTA"
        getDynamicData={() => ({ title })}
        type="link"
      >
        <Button
          href={buttonUrl}
          variant="contained"
          color="secondary"
          data-test-locator="Blog BlogCard Button"
        >
          {buttonText}
        </Button>
      </Track>
    </CardContent>
  </Card>
);

const BlogCard = withStyles(styles)(BlogCardInternal);
export { BlogCard };
